/** Demo list for organization-scoped chat; replace with API data later. */
export interface SampleCompany {
  id: string;
  name: string;
  /** Display format XX-XXXXXXX (sample values only). */
  ein: string;
  dba: string | null;
  addressLine1: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  email: string;
  website: string | null;
  fiscalYearEnd: string;
  incorporationDate: string;
  irsDeterminationLetter: string;
  contactName: string;
  contactTitle: string;
  mission: string;
  notes: string;
}

export const SAMPLE_COMPANIES: SampleCompany[] = [
  {
    id: '1',
    name: 'Riverbend Community Food Bank',
    ein: '47-1234567',
    dba: 'Riverbend Pantry',
    addressLine1: '1200 Mill Creek Rd',
    city: 'Riverside',
    state: 'OR',
    zip: '97031',
    phone: '(503) 555-0142',
    email: 'ops@riverbendfoodbank.example.org',
    website: 'https://riverbendfoodbank.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2003-03-18',
    irsDeterminationLetter: 'Letter dated 2004-08-02 (public charity)',
    contactName: 'Maria Chen',
    contactTitle: 'Executive Director',
    mission:
      'Distribute nutritious food to low-income families in Multnomah and surrounding counties while connecting clients to housing and benefits navigation.',
    notes:
      'Runs weekday pantry hours and a weekend mobile route. All sample data for UI review only.',
  },
  {
    id: '2',
    name: 'Lakeside Arts & Education Alliance',
    ein: '43-2345678',
    dba: null,
    addressLine1: '88 Lakeshore Dr, Suite 200',
    city: 'Madison',
    state: 'WI',
    zip: '53703',
    phone: '(608) 555-0198',
    email: 'hello@lakesidearts-edu.example.org',
    website: 'https://lakesidearts-edu.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '1998-11-05',
    irsDeterminationLetter: 'Letter dated 1999-04-14 (501(c)(3))',
    contactName: 'James Oberly',
    contactTitle: 'Board President',
    mission:
      'Provide subsidized arts instruction and literacy workshops for K–12 students in the Madison metro school district.',
    notes: 'Partners with MMSD for after-school programs. Sample profile for proofreading.',
  },
  {
    id: '3',
    name: 'North County Volunteer Fire Auxiliary',
    ein: '85-3456789',
    dba: 'NCVFA Support Fund',
    addressLine1: 'PO Box 440',
    city: 'Bellingham',
    state: 'WA',
    zip: '98227',
    phone: '(360) 555-0167',
    email: 'treasurer@ncvfaux.example.org',
    website: null,
    fiscalYearEnd: 'December 31',
    incorporationDate: '2010-01-22',
    irsDeterminationLetter: 'Letter dated 2010-09-30 (501(c)(3), supporting organization)',
    contactName: 'Lt. Dana Ng',
    contactTitle: 'Auxiliary Treasurer',
    mission:
      'Raise funds for equipment, training stipends, and family support for volunteer firefighters in Whatcom County.',
    notes: 'Fictitious EIN and contacts; use only for layout and copy review.',
  },
  {
    id: '4',
    name: 'Hope Street Youth Mentoring',
    ein: '82-4567890',
    dba: 'Hope Street',
    addressLine1: '450 Hope St',
    city: 'Philadelphia',
    state: 'PA',
    zip: '19134',
    phone: '(215) 555-0120',
    email: 'programs@hopestreet-mentor.example.org',
    website: 'https://hopestreet-mentor.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2007-07-09',
    irsDeterminationLetter: 'Letter dated 2008-01-17 (public charity)',
    contactName: 'Aaliyah Brooks',
    contactTitle: 'Program Director',
    mission:
      'Pair trained adult mentors with youth ages 12–18 in Kensington and adjacent neighborhoods.',
    notes: 'Demo data; verify against real CRM before any production use.',
  },
  {
    id: '5',
    name: 'Greenway Land Trust',
    ein: '27-5678901',
    dba: null,
    addressLine1: '22 Conservation Way',
    city: 'Asheville',
    state: 'NC',
    zip: '28801',
    phone: '(828) 555-0183',
    email: 'land@greenwaytrust.example.org',
    website: 'https://greenwaytrust.example.org',
    fiscalYearEnd: 'September 30',
    incorporationDate: '1995-02-14',
    irsDeterminationLetter: 'Letter dated 1995-11-20 (501(c)(3), conservation)',
    contactName: 'Samira Okonkwo',
    contactTitle: 'Stewardship Manager',
    mission:
      'Acquire and steward easements and parcels that protect river corridors and wildlife habitat in western North Carolina.',
    notes: 'Sample easement counts and acres omitted intentionally.',
  },
  {
    id: '6',
    name: 'Metro Free Clinic Partners',
    ein: '36-6789012',
    dba: 'MFCP Clinic Network',
    addressLine1: '900 Health Plaza, Bldg C',
    city: 'Columbus',
    state: 'OH',
    zip: '43215',
    phone: '(614) 555-0139',
    email: 'coordination@mfcp.example.org',
    website: 'https://mfcp.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2012-05-30',
    irsDeterminationLetter: 'Letter dated 2013-02-11 (501(c)(3))',
    contactName: 'Dr. Neil Patel',
    contactTitle: 'Medical Director',
    mission:
      'Operate volunteer-staffed clinics offering acute care and referrals for uninsured adults in central Ohio.',
    notes: 'All patient scenarios are fictional. Data for UX review only.',
  },
  {
    id: '7',
    name: 'Downtown Historic Preservation Society',
    ein: '94-7890123',
    dba: 'DHPS',
    addressLine1: '15 Court Square',
    city: 'Savannah',
    state: 'GA',
    zip: '31401',
    phone: '(912) 555-0171',
    email: 'archive@dhps-sav.example.org',
    website: 'https://dhps-sav.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '1988-10-01',
    irsDeterminationLetter: 'Letter dated 1989-06-07 (501(c)(3))',
    contactName: 'Helen Cordero',
    contactTitle: 'Archivist & Admin',
    mission:
      'Document and advocate for protection of contributing structures in the downtown historic district.',
    notes: 'Grant and membership figures not included in this demo profile.',
  },
  {
    id: '8',
    name: 'Sunrise Senior Companion Network',
    ein: '56-8901234',
    dba: 'Sunrise Companions',
    addressLine1: '300 Elder Ln',
    city: 'Tucson',
    state: 'AZ',
    zip: '85712',
    phone: '(520) 555-0155',
    email: 'volunteers@sunrise-companions.example.org',
    website: 'https://sunrise-companions.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2001-12-03',
    irsDeterminationLetter: 'Letter dated 2002-08-19 (501(c)(3))',
    contactName: 'Roberta Jiménez',
    contactTitle: 'Volunteer Coordinator',
    mission:
      'Match vetted volunteers with homebound seniors for weekly visits, transportation, and social connection.',
    notes: 'Fake phone and email; used to validate detail modal layout.',
  },
  {
    id: '9',
    name: 'Community Health Advocates Network',
    ein: '12-9012345',
    dba: 'CHAN Health',
    addressLine1: '750 Market St, Suite 400',
    city: 'San Francisco',
    state: 'CA',
    zip: '94103',
    phone: '(415) 555-0201',
    email: 'info@chanhealth.example.org',
    website: 'https://chanhealth.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2005-08-15',
    irsDeterminationLetter: 'Letter dated 2006-03-22 (501(c)(3))',
    contactName: 'Dr. Sarah Liu',
    contactTitle: 'Executive Director',
    mission: 'Provide health education and advocacy services to underserved communities in the Bay Area.',
    notes: 'Sample data for demonstration purposes only.',
  },
  {
    id: '10',
    name: 'Wildlife Rescue Coalition',
    ein: '23-0123456',
    dba: null,
    addressLine1: '1400 Forest Ave',
    city: 'Boulder',
    state: 'CO',
    zip: '80302',
    phone: '(303) 555-0178',
    email: 'rescue@wildlifecoalition.example.org',
    website: 'https://wildlifecoalition.example.org',
    fiscalYearEnd: 'September 30',
    incorporationDate: '2008-04-20',
    irsDeterminationLetter: 'Letter dated 2009-01-15 (501(c)(3))',
    contactName: 'Marcus Thompson',
    contactTitle: 'Director of Operations',
    mission: 'Rehabilitate injured wildlife and educate the public on coexistence with native species.',
    notes: 'Demo organization profile.',
  },
  {
    id: '11',
    name: 'Urban Youth Success Foundation',
    ein: '34-1234567',
    dba: 'UYSF',
    addressLine1: '920 N Main St',
    city: 'Detroit',
    state: 'MI',
    zip: '48226',
    phone: '(313) 555-0192',
    email: 'programs@uysf.example.org',
    website: 'https://uysf.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2010-09-12',
    irsDeterminationLetter: 'Letter dated 2011-04-08 (501(c)(3))',
    contactName: 'Tamika Williams',
    contactTitle: 'Program Director',
    mission: 'Support academic achievement and career readiness for youth in underresourced Detroit neighborhoods.',
    notes: 'Fictional data for UI testing.',
  },
  {
    id: '12',
    name: 'Coastal Habitat Restoration Trust',
    ein: '45-2345678',
    dba: 'Coastal Trust',
    addressLine1: '55 Bay View Rd',
    city: 'Charleston',
    state: 'SC',
    zip: '29401',
    phone: '(843) 555-0165',
    email: 'projects@coastaltrust.example.org',
    website: 'https://coastaltrust.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2000-06-05',
    irsDeterminationLetter: 'Letter dated 2001-02-14 (501(c)(3))',
    contactName: 'Jennifer Rhodes',
    contactTitle: 'Conservation Director',
    mission: 'Restore and protect coastal wetlands and estuaries in the South Carolina Lowcountry.',
    notes: 'Sample conservation nonprofit.',
  },
  {
    id: '13',
    name: 'Veterans Housing Initiative',
    ein: '56-3456789',
    dba: null,
    addressLine1: '2200 Veterans Pkwy',
    city: 'Nashville',
    state: 'TN',
    zip: '37203',
    phone: '(615) 555-0144',
    email: 'housing@vethousing.example.org',
    website: 'https://vethousing.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2013-11-11',
    irsDeterminationLetter: 'Letter dated 2014-05-20 (501(c)(3))',
    contactName: 'Lt. Col. Robert Martinez (Ret.)',
    contactTitle: 'Executive Director',
    mission: 'Provide transitional housing and support services for homeless veterans in Middle Tennessee.',
    notes: 'Demo profile for housing nonprofit.',
  },
  {
    id: '14',
    name: 'Creative Arts Academy for All',
    ein: '67-4567890',
    dba: 'Arts Academy',
    addressLine1: '88 Broad St',
    city: 'Providence',
    state: 'RI',
    zip: '02903',
    phone: '(401) 555-0189',
    email: 'admin@artsacademy.example.org',
    website: 'https://artsacademy.example.org',
    fiscalYearEnd: 'August 31',
    incorporationDate: '2006-01-10',
    irsDeterminationLetter: 'Letter dated 2006-09-25 (501(c)(3))',
    contactName: 'Elena Castillo',
    contactTitle: 'Artistic Director',
    mission: 'Offer free and low-cost visual and performing arts classes to children from low-income families.',
    notes: 'Sample arts education nonprofit.',
  },
  {
    id: '15',
    name: 'Clean Water Action Alliance',
    ein: '78-5678901',
    dba: 'CWAA',
    addressLine1: '1600 River Rd',
    city: 'Des Moines',
    state: 'IA',
    zip: '50316',
    phone: '(515) 555-0173',
    email: 'advocacy@cwaa-iowa.example.org',
    website: 'https://cwaa-iowa.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2009-03-14',
    irsDeterminationLetter: 'Letter dated 2009-11-30 (501(c)(3))',
    contactName: 'Michael Chen',
    contactTitle: 'Policy Director',
    mission: 'Advocate for agricultural practices that protect Iowa waterways from nutrient runoff.',
    notes: 'Demo environmental advocacy nonprofit.',
  },
  {
    id: '16',
    name: 'Family Support Services Center',
    ein: '89-6789012',
    dba: null,
    addressLine1: '440 Family Way',
    city: 'Albuquerque',
    state: 'NM',
    zip: '87102',
    phone: '(505) 555-0158',
    email: 'intake@familysupport.example.org',
    website: 'https://familysupport.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2004-05-18',
    irsDeterminationLetter: 'Letter dated 2005-01-11 (501(c)(3))',
    contactName: 'Rosa Gutierrez',
    contactTitle: 'Clinical Director',
    mission: 'Provide counseling, parenting education, and crisis intervention for families in Bernalillo County.',
    notes: 'Fictional family services nonprofit.',
  },
  {
    id: '17',
    name: 'Literacy Project of Central Maine',
    ein: '90-7890123',
    dba: 'Maine Literacy',
    addressLine1: '75 Main St',
    city: 'Augusta',
    state: 'ME',
    zip: '04330',
    phone: '(207) 555-0196',
    email: 'tutors@maineliteracy.example.org',
    website: 'https://maineliteracy.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '1997-10-22',
    irsDeterminationLetter: 'Letter dated 1998-06-05 (501(c)(3))',
    contactName: 'Patricia O\'Brien',
    contactTitle: 'Program Coordinator',
    mission: 'Improve adult literacy through one-on-one tutoring and small group instruction.',
    notes: 'Sample literacy nonprofit.',
  },
  {
    id: '18',
    name: 'Mountain Trails Conservancy',
    ein: '01-8901234',
    dba: null,
    addressLine1: 'PO Box 890',
    city: 'Bozeman',
    state: 'MT',
    zip: '59715',
    phone: '(406) 555-0162',
    email: 'trails@mtconservancy.example.org',
    website: 'https://mtconservancy.example.org',
    fiscalYearEnd: 'September 30',
    incorporationDate: '2011-07-04',
    irsDeterminationLetter: 'Letter dated 2012-03-19 (501(c)(3))',
    contactName: 'Kyle Anderson',
    contactTitle: 'Trail Steward',
    mission: 'Maintain and expand public hiking trails in Gallatin County while protecting natural habitats.',
    notes: 'Demo conservation organization.',
  },
  {
    id: '19',
    name: 'Community Legal Aid Society',
    ein: '12-9012346',
    dba: 'CLAS',
    addressLine1: '200 Justice Plaza',
    city: 'Hartford',
    state: 'CT',
    zip: '06103',
    phone: '(860) 555-0181',
    email: 'intake@clas-ct.example.org',
    website: 'https://clas-ct.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '1992-02-28',
    irsDeterminationLetter: 'Letter dated 1992-10-12 (501(c)(3))',
    contactName: 'Atty. Michael Rosenberg',
    contactTitle: 'Executive Director',
    mission: 'Provide free civil legal services to low-income residents in housing, family law, and benefits cases.',
    notes: 'Fictional legal aid nonprofit.',
  },
  {
    id: '20',
    name: 'Immigrant Welcome Center',
    ein: '23-0123457',
    dba: 'IWC',
    addressLine1: '1050 Liberty St',
    city: 'Minneapolis',
    state: 'MN',
    zip: '55414',
    phone: '(612) 555-0174',
    email: 'services@iwc-mn.example.org',
    website: 'https://iwc-mn.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2007-09-15',
    irsDeterminationLetter: 'Letter dated 2008-04-22 (501(c)(3))',
    contactName: 'Fatima Hassan',
    contactTitle: 'Program Manager',
    mission: 'Help new immigrants navigate resettlement through ESL classes, job placement, and legal referrals.',
    notes: 'Sample immigrant services nonprofit.',
  },
  {
    id: '21',
    name: 'Animal Rescue League of Central Kansas',
    ein: '34-1234568',
    dba: 'ARL Kansas',
    addressLine1: '600 Shelter Rd',
    city: 'Wichita',
    state: 'KS',
    zip: '67202',
    phone: '(316) 555-0186',
    email: 'adoptions@arlkansas.example.org',
    website: 'https://arlkansas.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2003-06-01',
    irsDeterminationLetter: 'Letter dated 2004-02-17 (501(c)(3))',
    contactName: 'Laura Bennett',
    contactTitle: 'Shelter Director',
    mission: 'Rescue, rehabilitate, and rehome abandoned and abused animals in south-central Kansas.',
    notes: 'Demo animal welfare nonprofit.',
  },
  {
    id: '22',
    name: 'Rural Healthcare Access Project',
    ein: '45-2345679',
    dba: null,
    addressLine1: '88 County Rd 12',
    city: 'Fargo',
    state: 'ND',
    zip: '58102',
    phone: '(701) 555-0169',
    email: 'outreach@ruralhealthnd.example.org',
    website: 'https://ruralhealthnd.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2012-04-10',
    irsDeterminationLetter: 'Letter dated 2013-01-08 (501(c)(3))',
    contactName: 'Dr. Emily Hanson',
    contactTitle: 'Medical Director',
    mission: 'Operate mobile health clinics serving remote farming communities in North Dakota.',
    notes: 'Fictional rural health nonprofit.',
  },
  {
    id: '23',
    name: 'Youth Sports Opportunity League',
    ein: '56-3456790',
    dba: 'YSOL',
    addressLine1: '1200 Athletic Dr',
    city: 'Omaha',
    state: 'NE',
    zip: '68102',
    phone: '(402) 555-0193',
    email: 'register@ysol-omaha.example.org',
    website: 'https://ysol-omaha.example.org',
    fiscalYearEnd: 'August 31',
    incorporationDate: '2009-01-20',
    irsDeterminationLetter: 'Letter dated 2009-09-14 (501(c)(3))',
    contactName: 'Coach David Miller',
    contactTitle: 'Athletic Director',
    mission: 'Provide free youth sports programs and equipment to children from low-income families.',
    notes: 'Sample youth sports nonprofit.',
  },
  {
    id: '24',
    name: 'Historic Theatre Preservation Fund',
    ein: '67-4567891',
    dba: null,
    city: 'Little Rock',
    state: 'AR',
    zip: '72201',
    phone: '(501) 555-0177',
    email: 'preservation@htpf.example.org',
    website: 'https://htpf.example.org',
    addressLine1: '320 Main St',
    fiscalYearEnd: 'December 31',
    incorporationDate: '1999-11-08',
    irsDeterminationLetter: 'Letter dated 2000-07-20 (501(c)(3))',
    contactName: 'Margaret Foster',
    contactTitle: 'Preservation Coordinator',
    mission: 'Restore and maintain historic performance venues while supporting local arts programming.',
    notes: 'Demo historic preservation nonprofit.',
  },
  {
    id: '25',
    name: 'Emergency Food Network',
    ein: '78-5678902',
    dba: 'EFN',
    addressLine1: '950 Food Bank Pkwy',
    city: 'Salt Lake City',
    state: 'UT',
    zip: '84101',
    phone: '(801) 555-0188',
    email: 'distribution@efn-utah.example.org',
    website: 'https://efn-utah.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2005-03-25',
    irsDeterminationLetter: 'Letter dated 2005-11-30 (501(c)(3))',
    contactName: 'Daniel Kim',
    contactTitle: 'Operations Manager',
    mission: 'Coordinate food distribution to partner pantries and meal programs across the Wasatch Front.',
    notes: 'Fictional food bank network.',
  },
  {
    id: '26',
    name: 'Refugee Resettlement Alliance',
    ein: '89-6789013',
    dba: 'RRA',
    addressLine1: '1800 Welcoming Way',
    city: 'Boise',
    state: 'ID',
    zip: '83702',
    phone: '(208) 555-0164',
    email: 'casework@rra-idaho.example.org',
    website: 'https://rra-idaho.example.org',
    fiscalYearEnd: 'September 30',
    incorporationDate: '2015-06-12',
    irsDeterminationLetter: 'Letter dated 2016-02-05 (501(c)(3))',
    contactName: 'Amira Said',
    contactTitle: 'Resettlement Director',
    mission: 'Support refugees with housing, employment, and integration services in the Treasure Valley.',
    notes: 'Sample refugee services nonprofit.',
  },
  {
    id: '27',
    name: 'Community Garden Alliance',
    ein: '90-7890124',
    dba: null,
    addressLine1: '225 Garden Ln',
    city: 'Portland',
    state: 'ME',
    zip: '04101',
    phone: '(207) 555-0191',
    email: 'plots@gardenalliance.example.org',
    website: 'https://gardenalliance.example.org',
    fiscalYearEnd: 'October 31',
    incorporationDate: '2010-04-15',
    irsDeterminationLetter: 'Letter dated 2011-01-20 (501(c)(3))',
    contactName: 'Thomas Green',
    contactTitle: 'Garden Coordinator',
    mission: 'Develop and maintain community gardens that increase food access and build neighborhood connections.',
    notes: 'Demo urban agriculture nonprofit.',
  },
  {
    id: '28',
    name: 'Disability Rights Advocacy Center',
    ein: '01-8901235',
    dba: 'DRAC',
    addressLine1: '500 Access Blvd',
    city: 'Oklahoma City',
    state: 'OK',
    zip: '73102',
    phone: '(405) 555-0175',
    email: 'legal@drac-ok.example.org',
    website: 'https://drac-ok.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2008-08-25',
    irsDeterminationLetter: 'Letter dated 2009-04-10 (501(c)(3))',
    contactName: 'Atty. Rebecca Sanders',
    contactTitle: 'Legal Director',
    mission: 'Protect and advance civil rights for people with disabilities through advocacy and litigation.',
    notes: 'Fictional disability rights nonprofit.',
  },
  {
    id: '29',
    name: 'Youth Crisis Hotline Network',
    ein: '12-9012347',
    dba: 'Crisis Network',
    addressLine1: '1400 Helpline Plaza',
    city: 'Las Vegas',
    state: 'NV',
    zip: '89101',
    phone: '(702) 555-0182',
    email: 'volunteers@crisisnetwork.example.org',
    website: 'https://crisisnetwork.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2006-09-30',
    irsDeterminationLetter: 'Letter dated 2007-05-15 (501(c)(3))',
    contactName: 'Dr. Linda Martinez',
    contactTitle: 'Clinical Director',
    mission: 'Provide 24/7 crisis intervention and mental health support for at-risk youth and families.',
    notes: 'Sample crisis services nonprofit.',
  },
  {
    id: '30',
    name: 'Performing Arts Education Fund',
    ein: '23-0123458',
    dba: 'PAEF',
    addressLine1: '88 Theater Row',
    city: 'Louisville',
    state: 'KY',
    zip: '40202',
    phone: '(502) 555-0190',
    email: 'programs@paef-ky.example.org',
    website: 'https://paef-ky.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2004-02-12',
    irsDeterminationLetter: 'Letter dated 2004-10-28 (501(c)(3))',
    contactName: 'Jonathan Wright',
    contactTitle: 'Education Director',
    mission: 'Bring professional theater, dance, and music performances to Title I schools across Kentucky.',
    notes: 'Demo performing arts education nonprofit.',
  },
  {
    id: '31',
    name: 'Homeless Outreach Services',
    ein: '34-1234569',
    dba: 'HOS',
    addressLine1: '600 Shelter Ave',
    city: 'Charleston',
    state: 'WV',
    zip: '25301',
    phone: '(304) 555-0168',
    email: 'outreach@hos-wv.example.org',
    website: 'https://hos-wv.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2011-12-01',
    irsDeterminationLetter: 'Letter dated 2012-07-18 (501(c)(3))',
    contactName: 'Maria Collins',
    contactTitle: 'Outreach Director',
    mission: 'Connect unhoused individuals with emergency shelter, healthcare, and permanent housing resources.',
    notes: 'Fictional homeless services nonprofit.',
  },
  {
    id: '32',
    name: 'River Valley Land Trust',
    ein: '45-2345680',
    dba: null,
    addressLine1: '1200 Conservation Dr',
    city: 'Burlington',
    state: 'VT',
    zip: '05401',
    phone: '(802) 555-0179',
    email: 'land@rvlt.example.org',
    website: 'https://rvlt.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '1996-05-20',
    irsDeterminationLetter: 'Letter dated 1997-01-30 (501(c)(3))',
    contactName: 'Catherine Brown',
    contactTitle: 'Land Protection Manager',
    mission: 'Conserve Vermont farmland and forest through easements and fee acquisitions.',
    notes: 'Sample land trust nonprofit.',
  },
  {
    id: '33',
    name: 'Job Training and Placement Center',
    ein: '56-3456791',
    dba: 'JTPC',
    addressLine1: '88 Career Ct',
    city: 'Jackson',
    state: 'MS',
    zip: '39201',
    phone: '(601) 555-0187',
    email: 'training@jtpc-ms.example.org',
    website: 'https://jtpc-ms.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2009-07-22',
    irsDeterminationLetter: 'Letter dated 2010-03-15 (501(c)(3))',
    contactName: 'Raymond Johnson',
    contactTitle: 'Workforce Director',
    mission: 'Provide vocational training and job placement for unemployed and underemployed adults.',
    notes: 'Demo workforce development nonprofit.',
  },
  {
    id: '34',
    name: 'Childrens Literacy Foundation',
    ein: '67-4567892',
    dba: 'CLF',
    addressLine1: '450 Book St',
    city: 'Wilmington',
    state: 'DE',
    zip: '19801',
    phone: '(302) 555-0194',
    email: 'books@clf-de.example.org',
    website: 'https://clf-de.example.org',
    fiscalYearEnd: 'August 31',
    incorporationDate: '2002-10-05',
    irsDeterminationLetter: 'Letter dated 2003-05-20 (501(c)(3))',
    contactName: 'Susan Park',
    contactTitle: 'Program Coordinator',
    mission: 'Distribute free books and promote early literacy through reading programs for children ages 0-5.',
    notes: 'Fictional early literacy nonprofit.',
  },
  {
    id: '35',
    name: 'Mental Health Crisis Response Team',
    ein: '78-5678903',
    dba: 'Crisis Team',
    addressLine1: '1100 Mental Health Way',
    city: 'Anchorage',
    state: 'AK',
    zip: '99501',
    phone: '(907) 555-0176',
    email: 'dispatch@crisisteam.example.org',
    website: 'https://crisisteam.example.org',
    fiscalYearEnd: 'September 30',
    incorporationDate: '2014-03-08',
    irsDeterminationLetter: 'Letter dated 2014-11-25 (501(c)(3))',
    contactName: 'Dr. James Peterson',
    contactTitle: 'Clinical Director',
    mission: 'Provide mobile crisis intervention and de-escalation services as alternative to law enforcement.',
    notes: 'Sample mental health crisis nonprofit.',
  },
  {
    id: '36',
    name: 'Farm to School Network',
    ein: '89-6789014',
    dba: null,
    addressLine1: '300 Farm Rd',
    city: 'Montpelier',
    state: 'VT',
    zip: '05602',
    phone: '(802) 555-0195',
    email: 'coordinator@farmtoschool.example.org',
    website: 'https://farmtoschool.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2008-05-14',
    irsDeterminationLetter: 'Letter dated 2009-01-22 (501(c)(3))',
    contactName: 'Emily Foster',
    contactTitle: 'Network Coordinator',
    mission: 'Connect Vermont schools with local farms to provide fresh, healthy meals and agricultural education.',
    notes: 'Demo farm-to-school nonprofit.',
  },
  {
    id: '37',
    name: 'Neighborhood Safety Coalition',
    ein: '90-7890125',
    dba: 'NSC',
    addressLine1: '700 Safety Plaza',
    city: 'Newark',
    state: 'NJ',
    zip: '07102',
    phone: '(973) 555-0172',
    email: 'programs@nsc-nj.example.org',
    website: 'https://nsc-nj.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2010-08-30',
    irsDeterminationLetter: 'Letter dated 2011-05-15 (501(c)(3))',
    contactName: 'Andre Williams',
    contactTitle: 'Community Organizer',
    mission: 'Reduce violence through community-led intervention, mediation, and youth mentoring programs.',
    notes: 'Fictional community safety nonprofit.',
  },
  {
    id: '38',
    name: 'Heritage Language Institute',
    ein: '01-8901236',
    dba: 'HLI',
    addressLine1: '88 Culture Ave',
    city: 'Honolulu',
    state: 'HI',
    zip: '96813',
    phone: '(808) 555-0184',
    email: 'classes@hli-hawaii.example.org',
    website: 'https://hli-hawaii.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2007-04-18',
    irsDeterminationLetter: 'Letter dated 2008-01-30 (501(c)(3))',
    contactName: 'Keiko Tanaka',
    contactTitle: 'Education Director',
    mission: 'Preserve and teach heritage languages and cultural traditions to second-generation immigrant youth.',
    notes: 'Sample cultural education nonprofit.',
  },
  {
    id: '39',
    name: 'Senior Technology Access Program',
    ein: '12-9012348',
    dba: 'STAP',
    addressLine1: '1500 Digital Way',
    city: 'Cheyenne',
    state: 'WY',
    zip: '82001',
    phone: '(307) 555-0197',
    email: 'training@stap-wy.example.org',
    website: 'https://stap-wy.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2016-09-10',
    irsDeterminationLetter: 'Letter dated 2017-04-25 (501(c)(3))',
    contactName: 'Margaret Thompson',
    contactTitle: 'Program Director',
    mission: 'Provide free technology training and devices to seniors to reduce digital isolation.',
    notes: 'Demo senior services nonprofit.',
  },
  {
    id: '40',
    name: 'Sustainable Agriculture Education Fund',
    ein: '23-0123459',
    dba: null,
    addressLine1: '600 Organic Farm Rd',
    city: 'Eugene',
    state: 'OR',
    zip: '97401',
    phone: '(541) 555-0170',
    email: 'education@saef.example.org',
    website: 'https://saef.example.org',
    fiscalYearEnd: 'October 31',
    incorporationDate: '2005-11-20',
    irsDeterminationLetter: 'Letter dated 2006-07-12 (501(c)(3))',
    contactName: 'Carlos Mendez',
    contactTitle: 'Farm Education Coordinator',
    mission: 'Train beginning farmers in organic and regenerative agriculture practices.',
    notes: 'Fictional sustainable agriculture nonprofit.',
  },
  {
    id: '41',
    name: 'Foster Youth Support Network',
    ein: '34-1234570',
    dba: 'FYSN',
    addressLine1: '1200 Family Ct',
    city: 'Birmingham',
    state: 'AL',
    zip: '35203',
    phone: '(205) 555-0185',
    email: 'support@fysn-al.example.org',
    website: 'https://fysn-al.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2012-06-15',
    irsDeterminationLetter: 'Letter dated 2013-02-20 (501(c)(3))',
    contactName: 'Jennifer Lewis',
    contactTitle: 'Executive Director',
    mission: 'Provide mentoring, life skills training, and transitional support for youth aging out of foster care.',
    notes: 'Sample foster care nonprofit.',
  },
  {
    id: '42',
    name: 'Public Transit Advocacy Coalition',
    ein: '45-2345681',
    dba: 'Transit Coalition',
    addressLine1: '88 Transit Plaza',
    city: 'Trenton',
    state: 'NJ',
    zip: '08608',
    phone: '(609) 555-0199',
    email: 'advocacy@transitcoalition.example.org',
    website: 'https://transitcoalition.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2009-02-25',
    irsDeterminationLetter: 'Letter dated 2009-10-15 (501(c)(3))',
    contactName: 'David Wong',
    contactTitle: 'Policy Director',
    mission: 'Advocate for expanded and equitable public transportation access in underserved communities.',
    notes: 'Demo transportation advocacy nonprofit.',
  },
  {
    id: '43',
    name: 'Cancer Support Services Alliance',
    ein: '56-3456792',
    dba: 'CSSA',
    addressLine1: '1800 Hope Dr',
    city: 'Richmond',
    state: 'VA',
    zip: '23219',
    phone: '(804) 555-0166',
    email: 'support@cssa-va.example.org',
    website: 'https://cssa-va.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2006-08-05',
    irsDeterminationLetter: 'Letter dated 2007-03-18 (501(c)(3))',
    contactName: 'Dr. Patricia Moore',
    contactTitle: 'Program Director',
    mission: 'Provide free support groups, transportation, and financial assistance to cancer patients and families.',
    notes: 'Fictional cancer support nonprofit.',
  },
  {
    id: '44',
    name: 'Watershed Protection League',
    ein: '67-4567893',
    dba: null,
    addressLine1: '500 Stream Rd',
    city: 'Concord',
    state: 'NH',
    zip: '03301',
    phone: '(603) 555-0180',
    email: 'protect@watershed-nh.example.org',
    website: 'https://watershed-nh.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2001-09-12',
    irsDeterminationLetter: 'Letter dated 2002-05-28 (501(c)(3))',
    contactName: 'Steven Clark',
    contactTitle: 'Conservation Director',
    mission: 'Monitor water quality and advocate for policies protecting New Hampshire rivers and lakes.',
    notes: 'Sample environmental nonprofit.',
  },
  {
    id: '45',
    name: 'Re-Entry Support Services',
    ein: '78-5678904',
    dba: 'RESS',
    addressLine1: '900 Second Chance Blvd',
    city: 'Baltimore',
    state: 'MD',
    zip: '21201',
    phone: '(410) 555-0198',
    email: 'services@ress-md.example.org',
    website: 'https://ress-md.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2013-10-20',
    irsDeterminationLetter: 'Letter dated 2014-06-15 (501(c)(3))',
    contactName: 'Marcus Green',
    contactTitle: 'Re-Entry Coordinator',
    mission: 'Help formerly incarcerated individuals reintegrate through job training, housing, and counseling.',
    notes: 'Demo re-entry services nonprofit.',
  },
  {
    id: '46',
    name: 'Indigenous Arts Preservation Society',
    ein: '89-6789015',
    dba: null,
    addressLine1: '1400 Heritage Way',
    city: 'Santa Fe',
    state: 'NM',
    zip: '87501',
    phone: '(505) 555-0163',
    email: 'programs@indigenous-arts.example.org',
    website: 'https://indigenous-arts.example.org',
    fiscalYearEnd: 'September 30',
    incorporationDate: '1999-12-10',
    irsDeterminationLetter: 'Letter dated 2000-08-22 (501(c)(3))',
    contactName: 'Maria Tafoya',
    contactTitle: 'Cultural Programs Director',
    mission: 'Preserve and promote traditional Indigenous art forms through education and exhibitions.',
    notes: 'Fictional cultural preservation nonprofit.',
  },
  {
    id: '47',
    name: 'Small Business Development Center',
    ein: '90-7890126',
    dba: 'SBDC',
    addressLine1: '700 Entrepreneur Plaza',
    city: 'Providence',
    state: 'RI',
    zip: '02903',
    phone: '(401) 555-0192',
    email: 'advising@sbdc-ri.example.org',
    website: 'https://sbdc-ri.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2008-03-15',
    irsDeterminationLetter: 'Letter dated 2008-11-30 (501(c)(3))',
    contactName: 'Lisa Rodriguez',
    contactTitle: 'Business Advisor',
    mission: 'Provide free business advising and training to entrepreneurs in underserved Rhode Island communities.',
    notes: 'Sample economic development nonprofit.',
  },
  {
    id: '48',
    name: 'Child Abuse Prevention Network',
    ein: '01-8901237',
    dba: 'CAPN',
    addressLine1: '1600 Safe Harbor Dr',
    city: 'Dover',
    state: 'DE',
    zip: '19901',
    phone: '(302) 555-0189',
    email: 'prevention@capn-de.example.org',
    website: 'https://capn-de.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2005-07-28',
    irsDeterminationLetter: 'Letter dated 2006-03-15 (501(c)(3))',
    contactName: 'Rachel Adams',
    contactTitle: 'Prevention Coordinator',
    mission: 'Prevent child abuse through parent education, home visiting, and community awareness programs.',
    notes: 'Demo child welfare nonprofit.',
  },
  {
    id: '49',
    name: 'Climate Action Education Fund',
    ein: '12-9012349',
    dba: null,
    addressLine1: '88 Green Future Blvd',
    city: 'Seattle',
    state: 'WA',
    zip: '98101',
    phone: '(206) 555-0171',
    email: 'education@climateaction.example.org',
    website: 'https://climateaction.example.org',
    fiscalYearEnd: 'June 30',
    incorporationDate: '2017-01-05',
    irsDeterminationLetter: 'Letter dated 2017-09-20 (501(c)(3))',
    contactName: 'Dr. Sarah Johnson',
    contactTitle: 'Education Director',
    mission: 'Educate youth and communities on climate science and empower local climate action initiatives.',
    notes: 'Fictional climate education nonprofit.',
  },
  {
    id: '50',
    name: 'Affordable Housing Coalition',
    ein: '23-0123460',
    dba: 'AHC',
    addressLine1: '1200 Housing Way',
    city: 'Austin',
    state: 'TX',
    zip: '78701',
    phone: '(512) 555-0196',
    email: 'policy@ahc-austin.example.org',
    website: 'https://ahc-austin.example.org',
    fiscalYearEnd: 'December 31',
    incorporationDate: '2011-05-18',
    irsDeterminationLetter: 'Letter dated 2012-01-30 (501(c)(3))',
    contactName: 'Carmen Flores',
    contactTitle: 'Policy Director',
    mission: 'Advocate for policies and funding that increase affordable housing availability in Central Texas.',
    notes: 'Sample housing advocacy nonprofit.',
  },
];

export function findSampleCompany(name: string, ein: string): SampleCompany | undefined {
  const n = name.trim();
  const e = ein.trim();
  return (
    SAMPLE_COMPANIES.find((c) => c.name === n && c.ein === e) ??
    SAMPLE_COMPANIES.find((c) => c.name === n) ??
    (e ? SAMPLE_COMPANIES.find((c) => c.ein === e) : undefined)
  );
}
